// Visão Executiva (Alocação de Pessoal + Custo Mão de Obra): cruza % de alocação com o custo
// individual de cada colaborador para calcular saúde da alocação ao longo do ano, ranking de
// custo de pessoal por projeto e ociosidade acumulada. Precisa chamar tanto o endpoint de
// Alocação de Pessoal quanto o de Custo Mão de Obra — por isso fica restrita à interseção de
// ROLES_ALOCACAO_PESSOAL e ROLES_MAO_DE_OBRA (expõe custo de pessoal por projeto, dado sensível,
// mesmo público de Custo Mão de Obra). Espelha backend/config.py — mantenha em sincronia com
// ROLES_MAO_DE_OBRA.
export const ROLES_VISAO_EXECUTIVA = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
